module.exports = __webpack_public_path__ + "img/icon_menu.e3d97ab9.svg";